import { Container } from "@mui/material";
import { requester } from "App";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useState } from "react";
import VendorInfoList from "../components/VendorInfoList";
import VerticalFlex from "layouts/flex/VerticalFlex";
import styles from "../../vendor/dashboard/VendorNewDashboard.module.css";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";

function VendorStoreManagement() {
    const { userName } = useContext(AuthContext);
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState({});
    const [stores, setStores] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            setIsLoading(true);
            Promise.all([
                new Promise(resolve => {
                    requester.getVendorSettlementFee(result => {
                        setTotalAmount(result.data);
                        resolve();
                    });
                }),
                new Promise(resolve => {
                    requester.findAllVendorStore(result => {
                        setStores(result.data);
                        resolve();
                    });
                })
            ]).finally(() => {
                setIsLoading(false);
            });
        }
    }, [isMounted]);

    return (
        <div className={styles.container}>
            <div className={styles.flexGrid}>

                {/* 매장 목록 */}
                {isLoading ? (
                    <div className={`${styles.flexBox} ${styles.wideBox}`}>
                        <div className={styles.card}>
                            <div className={styles.section}>
                                <div className={styles.sectionContent}>
                                    <div className={styles.loading}>데이터를 불러오는 중...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    stores && stores.map((data, index) => (
                        <div key={data.id} className={styles.flexBox}>
                            <div className={styles.card}>
                                <div className={styles.section}>
                                    <div className={styles.sectionTitle}>
                                        <div className={styles.statsHeader}>
                                            <span>{data.storeName}</span>
                                        </div>
                                    </div>
                                    <div className={styles.sectionContent}>
                                        <VendorInfoList data={data} url={`/vendor/storeManagement/detail/${data.id}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default VendorStoreManagement;